import Dashboard from "../layouts/Dashboard/Dashboard.jsx";
import Auth from "../layouts/Auth/Auth";

const indexRoutes = [{ path: "/auth/", component: Auth }, { path: "/", component: Dashboard }];

export default indexRoutes;
